import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth, FetchBaseQuery } from './FetchBaseQuery';

export const roleApi = createApi({
   reducerPath: 'roleApi',
   baseQuery: baseQueryWithReauth,
   endpoints: (builder) => ({
      getRoles: builder.query({
         query: () => ({
            url: `/role`,
            method: 'GET',
         }),
         async onQueryStarted(queryArg, { queryFulfilled }) {
            try {
               const { data } = await queryFulfilled;
               return data;
            } catch (err) {
               return err;
            }
         },
      }),

      getList: builder.query({
         query: ({ page = 1, limit = 10, search = '' }) => ({
            url: `/role/list?page=${page}&limit=${limit}&search=${search}`,
            method: 'GET',
         }),
         providesTags: ['RoleList'],
         async onQueryStarted(queryArg, { queryFulfilled }) {
            try {
               const { data } = await queryFulfilled;
               return data;
            } catch (err) {
               return err;
            }
         },
      }),

      getModuleList: builder.query({
         query: () => ({
            url: `/role/modules`,
            method: 'GET',
         }),
         async onQueryStarted(queryArg, { queryFulfilled }) {
            try {
               const { data } = await queryFulfilled;
               return data;
            } catch (err) {
               return err;
            }
         },
      }),

      getPermissionList: builder.query({
         query: () => ({
            url: `/role/permissions`,
            method: 'GET',
         }),
         async onQueryStarted(queryArg, { queryFulfilled }) {
            try {
               const { data } = await queryFulfilled;
               return data;
            } catch (err) {
               return err;
            }
         },
      }),
      createRole: builder.mutation({
         query: (body) => ({
            url: `/role`,
            method: 'POST',
            body,
         }),
         invalidatesTags: ['RoleList'],
         async onQueryStarted(queryArg, { queryFulfilled }) {
            try {
               const { data } = await queryFulfilled;
               return data;
            } catch (err) {
               return err;
            }
         },
      }),

      getRoleDetail: builder.query({
         query: (id) => ({
            url: `/role/${id}`,
            method: 'GET',
         }),
         providesTags: (result, error, id) => [{ type: 'Role', id }],
         async onQueryStarted(queryArg, { queryFulfilled }) {
            try {
               const { data } = await queryFulfilled;
               return data;
            } catch (err) {
               return err;
            }
         },
      }),

      editRole: builder.mutation({
         query: (body) => ({
            url: `/role`,
            method: 'PUT',
            body,
         }),
         invalidatesTags: (result, error, arg) => [{ type: 'Role', id: arg.roleId }, 'RoleList'],
         async onQueryStarted(queryArg, { queryFulfilled }) {
            try {
               const { data } = await queryFulfilled;
               return data;
            } catch (err) {
               return err;
            }
         },
      }),
      deleteRole: builder.mutation({
         query: (id) => ({
            url: `/role/${id}`,
            method: 'DELETE',
         }),
         invalidatesTags: (result, error, id) => [{ type: 'Role', id }, 'RoleList'],
      }),
   }),
});

export const {
   useGetRolesQuery,
   useGetListQuery,
   useGetModuleListQuery,
   useGetPermissionListQuery,
   useCreateRoleMutation,
   useEditRoleMutation,
   useGetRoleDetailQuery,
   useDeleteRoleMutation,
} = roleApi;
